import React from "react";
import Media from "react-responsive";

import Navbar from "../components/general/navbar/Navbar";
import Footer from "../components/general/Footer";
import ScrollMenu from "../components/pages/projects/ScrollMenu";
import StaticMenu from "../components/pages/projects/StaticMenu";

import MobileNavbar from "../components/mobile/MobileNavbar";
import MobileFooter from "../components/mobile/MobileFooter";

const FeaturedProjects = () => {
  const imageUrl = "/prjimg/121Broadway/0.webp";
  
  return (
    <div className="">
      <Media query="(max-width: 768px)">
        {(isMobile) =>
          isMobile ? <MobileNavbar /> : <Navbar absolute={false} color="navy" />
        }
      </Media>
      <div className="flex flex-col justify-center items-center text-center p-3 md:p-5">
        <div className="w-full text-center">
            <h1 className="pb-5 text-4xl font-display font-regular text-navy animate-fadein">
              Featured Projects
            </h1>
          </div>
        <Media query="(max-width: 768px)">
          {(isMobile) =>
            isMobile ? <ScrollMenu /> : <StaticMenu />
          }
        </Media>
      </div>
      <br />
      <div className="animate-fadein">
        <Media query="(max-width: 768px)">
      {(isMobile) =>
        isMobile ? (
          // ✅ Mobile layout
          <div>
            <div className="flex image-container px-4 pt-3 justify-center">
              <img src={imageUrl} className="flex max-w-sm" alt="121 Broadway" />
            </div>
            <br />
            <div className="flex flex-col justify-center text-navy p-4 text-center">
              <h1 className="font-semi text-3xl">121 Broadway</h1>
              <h2 className="font-semi text-lg pt-2">
                City: <span className="font-regular">Cambridge, MA</span> <br />
                Developer: <span className="font-regular">BXP</span> <br />
                Architect: <span className="font-regular">Stantec</span> <br />
                General Contractor: <span className="font-regular">Turner</span> <br />
                Size (SF): <span className="font-regular">487,000</span> <br />
                Year: <span className="font-regular">2025</span> <br />
              </h2>
            </div>
          </div>
        ) : (
          // ✅ Desktop layout
          <div className="fade-in flex flex-col justify-center">
            <div className="flex font-display justify-center">
              <div className="flex w-1/2 justify-end">
              <div className="image-container">
                <img src={imageUrl} className="flex justify-end max-w-sm" alt="121 Broadway" />
              </div>
              </div>
              <div className="flex w-1/2 items-center">
              <div className="flex flex-col justify-start items-start text-navy p-5 w-1/3">
                <h1 className="font-semi text-3xl">121 Broadway</h1>
                <h2 className="font-semi text-lg pt-5">
                  City: <span className="font-regular">Cambridge, MA</span> <br />
                  Developer: <span className="font-regular">BXP</span> <br />
                  Architect: <span className="font-regular">Stantec</span> <br />
                  General Contractor: <span className="font-regular">Turner</span> <br />
                  Size (SF): <span className="font-regular">487,000</span> <br />
                  Year: <span className="font-regular">2025</span> <br />
                </h2>
              </div>

              </div>
              
              
            </div>
            <br />
            <br />
          </div>
        )
      }
    </Media>
      </div>
      <br />
      
      <Media query="(max-width: 768px)">
        {(isMobile) => (isMobile ? <MobileFooter /> : <Footer />)}
      </Media>
    </div>
  );
};

export default FeaturedProjects;
